/**
 * OrbDocTutorialsIntermediateUiPatternsENDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocTutorialsIntermediateUiPatternsENDocScreen
 */

import { useOrbDocTutorialsIntermediateUiPatternsENDocScreenLogic } from '@/hooks/traits/useOrbDocTutorialsIntermediateUiPatternsENDocScreenLogic';
import type { OrbDocTutorialsIntermediateUiPatternsENDocScreenConfig } from '@/hooks/traits/useOrbDocTutorialsIntermediateUiPatternsENDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocTutorialsIntermediateUiPatternsENDocView as OrbDocTutorialsIntermediateUiPatternsENDocViewEntity } from '@app/shared';
import { OrbDocTutorialsIntermediateUiPatternsENDocBodyView } from '@/components/traits/OrbDocTutorialsIntermediateUiPatternsENDocBodyView';
import { OrbDocTutorialsIntermediateUiPatternsENDocFooterView } from '@/components/traits/OrbDocTutorialsIntermediateUiPatternsENDocFooterView';
import { OrbDocTutorialsIntermediateUiPatternsENDocHeaderView } from '@/components/traits/OrbDocTutorialsIntermediateUiPatternsENDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocTutorialsIntermediateUiPatternsENDocScreenViewProps {
  config?: Partial<OrbDocTutorialsIntermediateUiPatternsENDocScreenConfig>;
}

export function OrbDocTutorialsIntermediateUiPatternsENDocScreenView({ config: propsConfig }: OrbDocTutorialsIntermediateUiPatternsENDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocTutorialsIntermediateUiPatternsENDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocTutorialsIntermediateUiPatternsENDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocTutorialsIntermediateUiPatternsEN" trait="OrbDocTutorialsIntermediateUiPatternsENDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocTutorialsIntermediateUiPatternsENDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocTutorialsIntermediateUiPatternsENDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsIntermediateUiPatternsENDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsIntermediateUiPatternsENDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocTutorialsIntermediateUiPatternsENDocScreenView;
